// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_Lzy25","icon":"index_icon_1kcdN"};